/* global axios */
import ApiClient from './ApiClient';

class InboxOnlyMembers extends ApiClient {
  constructor() {
    super('inbox_only_members', { accountScoped: true });
  }

  get(inboxIds, teamId = null) {
    const params = { inbox_ids: inboxIds };
    if (teamId) {
      params.team_id = teamId;
    }
    
    return axios.get(this.url, { params });
  }
}

export default new InboxOnlyMembers();
